import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import type { INoRowsOverlayAngularComp } from 'ag-grid-angular';
import type { INoRowsOverlayParams } from 'ag-grid-community';
import { IconSanitizerService } from 'ngx-lib';

type CustomNoRowsOverlayParams = INoRowsOverlayParams & {
    noRowsMessage: string;
};

@Component({
    selector: 'app-custom-no-rows-overlay',
    templateUrl: './custom-no-rows-overlay.component.html',
    styleUrls: ['./custom-no-rows-overlay.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: []
})
export class CustomNoRowsOverlayComponent implements INoRowsOverlayAngularComp, OnInit {
    public params!: CustomNoRowsOverlayParams;
    public svg?: SafeHtml;

    constructor(private readonly iconSanitizer: IconSanitizerService) {}

    ngOnInit(): void {
        this.svg = this.iconSanitizer.getIcon('emptyData');
    }

    agInit(params: INoRowsOverlayParams): void {
        this.refresh(params as CustomNoRowsOverlayParams);
    }

    refresh(params: CustomNoRowsOverlayParams): void {
        this.params = params;
    }
}
